import styles from './MaskActions.module.scss';

import { memo } from 'react';

export interface IMaskActionsProps {
  children?: React.ReactNode;
}

function MaskActionsInternal(props: IMaskActionsProps) {
  const { children } = props;

  return (
    <div className={styles.root}>
      <div className={styles.buttons}>{children}</div>
    </div>
  );
}

export const MaskActions = memo(MaskActionsInternal);
